var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353",
    "data-name": "Grupo 353",
    transform: "translate(-972 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_351",
    "data-name": "Grupo 351",
    transform: "translate(-5 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    transform: "translate(977 18)",
    fill: "none",
    stroke: "#122866",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MDI_account",
    "data-name": "MDI / account",
    transform: "translate(978.741 30.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "none",
    stroke: "#122866",
    strokeWidth: 1.5,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.592,
    height: 26.592,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 25.092,
    height: 25.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_account",
    "data-name": "Path / account",
    d: "M12.864,4A4.432,4.432,0,1,1,8.432,8.432,4.432,4.432,0,0,1,12.864,4m0,11.08c4.9,0,8.864,1.983,8.864,4.432v2.216H4V19.512C4,17.063,7.967,15.08,12.864,15.08Z",
    transform: "translate(0.432 0.432)",
    fill: "none",
    stroke: "#122866",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeader);
export default __webpack_public_path__ + "static/media/user-header.63376cc211334b53a36c7f9834a1590d.svg";
export { ForwardRef as ReactComponent };